import { observer } from 'mobx-react-lite'
import React, { Fragment, useMemo } from 'react'
import { Building } from 'react-bootstrap-icons'
import getUnicodeFlagIcon from 'country-flag-icons/unicode'
import Switch from '../../../../../FormComponents/Switch'

export default observer(function Cities({ authentications, values, setFieldValue, advSideScenario }) {

  const city = useMemo(() => {
    if (authentications.length === 0) return null;
    
    // Create a map to combine city data by city name
    const cityMap = new Map();
    
    authentications.forEach(auth => {
      if (['tiktok', 'youtube'].includes(auth.provider)) return;
      
      const cityData = auth?.audience_information?.detailed_audience_stats?.city;
      if (!cityData) return;
      
      cityData.forEach(item => {
        if (!item || !item.name) return;
        
        const cityKey = `${item.name}-${item.country_code || ''}`;
        const existing = cityMap.get(cityKey);
        if (existing) {
          existing.count++;
          existing.percentage += item.percentage || 0;
        } else {
          cityMap.set(cityKey, {
            name: item.name,
            percentage: item.percentage || 0,
            count: 1
          });
        }
      });
    });
    
    // Calculate average percentages and convert to array
    return Array.from(cityMap.values())
      .map(item => ({
        name: item.name,
        percentage: item.percentage / item.count
      }))
      .sort((a, b) => b.percentage - a.percentage);
  }, [authentications]);

  const percentageSum = useMemo(() => city && (city.slice(0, 10).reduce((result, { percentage }) => result + percentage, 0) * 100).toFixed(2), [city]);

  // Skip rendering if no valid data
  if (!city || city.length === 0) return null;

  return (
    <div className="flex flex-col h-full border-1 border-border-primary dark:border-rb-dark-mode-lighter rounded-lg">
      <div className="flex items-center p-4 border-b-1 border-border-primary dark:border-rb-dark-mode-lighter">
        <div className={`text-rb-lighter-grey mr-2 ${advSideScenario || values.audience_cities_visible ? '' : 'opacity-30'}`}>
          <Building />
        </div>
        <p className={`font-bold text-xl dark:text-white ${advSideScenario || values.audience_cities_visible ? '' : 'opacity-30'}`}>Audience Cities</p>
        {!advSideScenario && <Switch name="audience_cities_visible" value={values.audience_cities_visible} onChange={({ target: { checked }}) => setFieldValue('audience_cities_visible', checked, true)} eyeSwitch />}
      </div>
      <div className={`${advSideScenario || values.audience_cities_visible ? '' : 'opacity-30'}`}>
        <div className="grid grid-cols-2">
          {city && [...Array(5)].map((_, i) => (
            <Fragment key={i}>
              <div className="flex justify-between border-r-1 border-b-1 border-border-primary dark:border-rb-dark-mode-lighter">
                <p className="p-4 font-bold dark:text-white">{city[i]?.name}</p>
                <p className="p-4 font-bold dark:text-white">{city[i] ? (city[i].percentage * 100).toFixed(2) : 0}%</p>
              </div>
              <div className="flex justify-between border-b-1 border-border-primary dark:border-rb-dark-mode-lighter">
                <p className="p-4 font-bold dark:text-white">{city[i + 5]?.name}</p>
                <p className="p-4 font-bold dark:text-white">{city[i + 5] ? (city[i + 5].percentage * 100).toFixed(2) : 0}%</p>
              </div>
            </Fragment>
          ))
          }
        </div>
        <div className="flex items-center p-4">
          <p className="font-bold text-rb-lighter-grey mr-2 dark:text-gray-400">Total of visible cities</p>
          <p className="font-bold dark:text-white">{percentageSum}%</p>
        </div>
      </div>
    </div>
  )
})